import api from './api'

export interface PermissionType {
  id: number
  companyId?: string | null
  name: string
  description?: string | null
  createdAt: string
  updatedAt: string
}

export interface RoleType {
  id: number
  companyId?: string | null
  name: string
  description?: string | null
  createdAt: string
  updatedAt: string
  permissions?: PermissionType[]
}

export interface CreatePermissionPayloadType {
  name: string
  description?: string
}

export interface CreateRolePayloadType {
  name: string
  description?: string
}

export const permissionService = {
  async listPermissions() {
    const { data } = await api.get('/permissions')
    return data.data as PermissionType[]
  },

  async getPermission(id: number) {
    const { data } = await api.get(`/permissions/${id}`)
    return data.data as PermissionType
  },

  async createPermission(payload: CreatePermissionPayloadType) {
    const { data } = await api.post('/permissions', payload)
    return data.data as PermissionType
  },

  async updatePermission(id: number, payload: Partial<CreatePermissionPayloadType>) {
    const { data } = await api.put(`/permissions/${id}`, payload)
    return data.data as PermissionType
  },

  async deletePermission(id: number) {
    const { data } = await api.delete(`/permissions/${id}`)
    return data.data as boolean
  },

  async listRoles(params?: { name?: string; description?: string }) {
    const { data } = await api.get('/roles', { params })
    return data.data as RoleType[]
  },

  async getRole(id: number) {
    const { data } = await api.get(`/roles/${id}`)
    return data.data as RoleType
  },

  async createRole(payload: CreateRolePayloadType) {
    const { data } = await api.post('/roles', payload)
    return data.data as RoleType
  },

  async updateRole(id: number, payload: Partial<CreateRolePayloadType>) {
    const { data } = await api.put(`/roles/${id}`, payload)
    return data.data as RoleType
  },

  async deleteRole(id: number) {
    const { data } = await api.delete(`/roles/${id}`)
    return data.data as boolean
  },

  async assignPermissionToRole(roleId: number, permissionId: number) {
    const { data } = await api.post(`/roles/${roleId}/permissions`, { permissionId })
    return data.data
  },

  async removePermissionFromRole(roleId: number, permissionId: number) {
    const { data } = await api.delete(`/roles/${roleId}/permissions/${permissionId}`)
    return data.data as boolean
  },

  async assignRoleToUser(userId: number, roleId: number) {
    const { data } = await api.post(`/users/${userId}/role`, { roleId })
    return data.data as boolean
  },

  async removeRoleFromUser(userId: number, roleId: number) {
    const { data } = await api.delete(`/users/${userId}/role/${roleId}`)
    return data.data as boolean
  },

  async assignPermissionToUser(userId: number, permissionId: number) {
    const { data } = await api.post(`/users/${userId}/permissions`, { permissionId })
    return data.data as boolean
  },

  async removePermissionFromUser(userId: number, permissionId: number) {
    const { data } = await api.delete(`/users/${userId}/permissions/${permissionId}`)
    return data.data as boolean
  }
}
